import { create } from 'zustand';

export type TUpdateDetailCustomer = {
  name: string;
  address: string;
  city: string;
  country: string;
  email: string;
  gender: 'MALE' | 'FEMALE';
  interest: string;
  phoneNumber: string;
  notes: string;
};

export type TShowData = {
  [K in keyof Omit<TUpdateDetailCustomer, 'notes'>]: boolean;
};

export const DEFAULT_SHOW_DATA: TShowData = {
  name: true,
  email: false,
  phoneNumber: false,
  address: false,
  gender: false,
  city: false,
  country: false,
  interest: false,
};

interface IUpdateDetailCustomerModalStore {
  /**
   * State
   */
  showData: TShowData;

  /**
   * Actions
   */
  setShowData: (showData: TShowData) => void;
  resetShowData: () => void;
}

export const useUpdateDetailCustomerModalStore = create<IUpdateDetailCustomerModalStore>((set) => ({
  /**
   * State
   */
  showData: DEFAULT_SHOW_DATA,

  /**
   * Actions
   */
  setShowData: (showData) => {
    set({ showData });
  },

  resetShowData: () => {
    set({ showData: DEFAULT_SHOW_DATA });
  },
}));
